import Button from '@klv/atoms/button/variants/button';
import Icon from '@klv/atoms/icon';
import Typography from '@klv/atoms/typography';
import type { TColorVariant } from '@klv/shared/styles/types';
import styled from 'styled-components';

export const RecaptchaContainer = styled.div`
  margin-bottom: 2rem;
`;

export const ErrorContainer = styled.div`
  margin: 1rem 0;
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FormError = styled(Typography)<{
  $backgroundColor: TColorVariant;
}>`
  color: ${({ theme, $backgroundColor }) => theme.form[$backgroundColor].error};
`;

export const OtherSupport = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const SuccessHeadline = styled(Typography)`
  margin-bottom: 2.4rem;
`;

export const SuccessSubhead = styled(Typography)`
  margin-bottom: 4rem;
`;

export const StyledIcon = styled(Icon)`
  display: inline-block;
  font-size: 4rem;
  margin-bottom: 2.4rem;
`;

export const SuccessContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const MfaSupportFieldsInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding-top: 2.5rem;
`;

export const MfaSupportFieldsInfoBox = styled.div`
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding-bottom: 2.5rem;
`;
